/* global GQL_ROOT */

import { ApolloClient } from 'apollo-client';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'; // eslint-disable-line
import authService from '../auth';

const httpLink = new BatchHttpLink({ uri: GQL_ROOT });

const middlewareLink = setContext(() => {
  const headers = {};
  if (authService.getUserCookie()) {
    headers['User-Id'] = authService.getUserCookie();
  }
  if (authService.getAuthCookie()) {
    headers.authorization = `Bearer ${authService.getAuthCookie()}`;
  }
  return ({ headers });
});

const errorLink = onError(({ graphQLErrors }) => {
  // Currently, graphql-tools remote executable schemas do not pass through
  // the custom error code property so we are having to use the less reliable error message
  if (graphQLErrors && graphQLErrors.map(e => e.message).includes('Access denied')) {
    authService.logout();
  }
});

const link = errorLink.concat(middlewareLink).concat(httpLink);

export const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [
        {
          kind: 'UNION',
          name: 'BookingFormField',
          possibleTypes: [
            { name: 'BookingFormAddressField' },
            { name: 'BookingFormCheckBoxesField' },
            { name: 'BookingFormDateField' },
            { name: 'BookingFormGroupSelectField' },
            { name: 'BookingFormEmailField' },
            { name: 'BookingFormHeadingField' },
            { name: 'BookingFormRadioButtonsField' },
            { name: 'BookingFormSelectField' },
            { name: 'BookingFormTextAreaField' },
            { name: 'BookingFormTextField' },
          ],
        },
      ],
    },
  },
});

export default new ApolloClient({
  link,
  cache: new InMemoryCache({ fragmentMatcher }),
});



// WEBPACK FOOTER //
// ./app/src/state/services/gql/index.js